'use client';

import { createContext } from 'react';

export type ToastSeverity = 'success' | 'error' | 'warning' | 'info';

export type ToastItem = {
  id: string;
  callerId: string;
  message: string;
  severity: ToastSeverity;
  open: boolean;
  autoHide: boolean;
};

export type AddOrReplaceToast = (
  callerId: string,
  message: string,
  severity: ToastSeverity,
  autoHide: boolean
) => void;

export type ToastMethods = {
  success: (message: string) => void;
  error: (message: string) => void;
  warning: (message: string) => void;
  info: (message: string) => void;
};

export type ToastContextValue = (callerId?: string) => ToastMethods;

export const ToastContext = createContext<ToastContextValue | null>(null);
